import React from 'react';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  addSection,
  addContentBlock,
  saveStore,
  loadStore,
  publish,
  removeSection,
  removeContentBlock,
  updateSections,
  moveContentBlock
} from '../store/editStoreActions';
import {
  Jumbotron,
  Card,
  CardBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Button
} from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import Sections from '../components/landingPage/Sections/Sections';
import './Edit.css';
import SaveChanges from '../components/SaveChanges/SaveChanges';
import StoreConfig from '../components/StoreConfig/StoreConfig';
import Categories from '../components/categories/Categories/Categories';
import RestoreStore from '../components/RestoreStore/RestoreStore';

class Edit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sections: [],
      activeTab: '1',
      openFromOpen: false,
      editStoreConfig: true,
      showRestoreModal: false,
      changeCount: 0
    };
  }

  componentDidMount() {
    if (!this.props.activeStore) {
      this.props.changePage('/');
    }
    if (this.props.match.params.storeId && this.props.match.params.version) {
      this.props.loadStore(
        this.props.match.params.storeId,
        '',
        this.props.match.params.version
      );
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.activeStore) {
      return {
        sections: nextProps.activeStore.landingPage.sections,
        categories: nextProps.activeStore.categories
      };
    }
    return null;
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  toggleOpenFrom() {
    this.setState({
      openFromOpen: !this.state.openFromOpen
    });
  }

  render() {
    const {
      activeStore,
      saveStore,
      loadStore,
      activeStoreId,
      modified,
      removeSection,
      addContentBlock,
      addSection,
      removeContentBlock,
      updateSections,
      moveContentBlock,
      imageBasePath,
      publish,
      version
    } = this.props;

    if (!activeStore) {
      return null;
    }

    const { name } = activeStore;
    const { sections } = this.state;

    return (
      <React.Fragment>
        <Breadcrumb>
          <Container className="px-4">
            <BreadcrumbItem>
              <Link to="/">Stores</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>
              <span>
                {name} ({version})
              </span>
            </BreadcrumbItem>
          </Container>
        </Breadcrumb>

        <Container>
          <Jumbotron className="text-center py-3">
            <h1 className="mb-3">
              {name} <small>({version})</small>
            </h1>
            <Button
              onClick={() => {
                this.setState({ showRestoreModal: true });
              }}
              color="primary"
            >
              Restore previous version
            </Button>
            <RestoreStore
              show={this.state.showRestoreModal}
              onClose={() => {
                this.setState({ showRestoreModal: false });
              }}
            />
            <hr className="dotted mt-4" />
            <StoreConfig environment={version} />
          </Jumbotron>

          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === '1' })}
                onClick={() => {
                  this.toggleTab('1');
                }}
              >
                Landing page
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: this.state.activeTab === '2' })}
                onClick={() => {
                  this.toggleTab('2');
                }}
              >
                Categories
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <Card
                className={`sections ${activeStoreId} ${
                  activeStore.theme
                }-theme `}
              >
                <CardBody>
                  <Sections
                    sections={sections}
                    imageBasePath={imageBasePath}
                    addSection={() => addSection()}
                    addContentBlock={(id, data) => addContentBlock(id, data)}
                    removeSection={sectionIndex => removeSection(sectionIndex)}
                    removeContentBlock={(sectionIndex, contentBlockIndex) =>
                      removeContentBlock(sectionIndex, contentBlockIndex)
                    }
                    updateSections={(sectionIndex, sectionsData) =>
                      updateSections(sectionIndex, sectionsData)
                    }
                    onMoveContentBlock={(
                      srcSectionIdx,
                      srcContentBlockIdx,
                      dstSectionIdx,
                      dstContentBlockIdx
                    ) => {
                      moveContentBlock(
                        srcSectionIdx,
                        srcContentBlockIdx,
                        dstSectionIdx,
                        dstContentBlockIdx
                      );
                    }}
                  />
                </CardBody>
              </Card>
            </TabPane>
            <TabPane tabId="2">
              <Card className={`sections categories`}>
                <CardBody>
                  <Categories
                    changeCount={this.state.changeCount}
                    imageBasePath={imageBasePath}
                  />
                </CardBody>
              </Card>
            </TabPane>
          </TabContent>
          <SaveChanges
            saveStore={() => saveStore(activeStoreId, activeStore)}
            loadStore={() =>
              loadStore(activeStoreId, name, version).then(() =>
                this.setState({
                  changeCount: (this.state.changeCount || 0) + 1
                })
              )
            }
            modified={modified}
            publish={publish}
            activeStore={activeStore}
            activeStoreId={activeStoreId}
          />
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ activeStore }) => ({
  activeStore: activeStore.activeStore
    ? activeStore[activeStore.activeStore]
    : null,
  activeStoreId: activeStore.activeStore,
  modified: activeStore.modified,
  imageBasePath:
    activeStore.activeStore && activeStore[activeStore.activeStore]
      ? activeStore[activeStore.activeStore].imageBasePath
      : null,
  version: activeStore.version
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addSection: () => addSection(),
      removeSection: sectionIndex => removeSection(sectionIndex),
      updateSections: sectionsData => updateSections(sectionsData),
      addContentBlock: (sectionId, contentBlock) =>
        addContentBlock(sectionId, contentBlock),
      removeContentBlock: (sectionIndex, contentBlockIndex) =>
        removeContentBlock(sectionIndex, contentBlockIndex),
      changePage: route => push(route),
      saveStore,
      publish,
      moveContentBlock,
      loadStore
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Edit);

export { Edit };



// WEBPACK FOOTER //
// ./src/containers/Edit.js